import{a as e}from"./chunk-RAAYCPUM.js";function t(...n){return e(r,n)}var r=(n,d)=>n+d;export{t as a};
